import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import HomeView from "../views/HomeView.vue";
import Login from "../views/login.vue";
import DegreeView from "../views/DegreeView.vue";
import UserView from "@/views/User.vue";
import DepartmentView from "@/views/Department/Index.vue";
import ProgramView from "@/views/ProgramView.vue";
import CoursesView from "@/views/Course/coursesView.vue";
import PartnerView from "@/views/Partner";
import viewPartnerLink from "@/views/Partner/viewPartnerLink";
import ProgramApplicationSchedule from "@/views/ProgramApplicationSchedule.vue";
import ProgramPartnerSchedule from "@/views/ProgramPartnerSchedule/index.vue";
import viewPartnerScheduleLink from "@/views/ProgramPartnerSchedule/viewPartnerScheduleLink.vue";
import SubPartner from "@/views/SubPartner";
import viewSubPartnerLink from "@/views/SubPartner/viewSubPartnerLink.vue";
import PartnerBranches from "@/views/PartnerBranch";
import GenerateCodeView from "@/views/GenerateCodeView.vue";
import OverallDepartmentsView from "@/views/Department/DepartmentView.vue";
import DepartmentCourse from "@/views/Department/ViewCourse.vue";
import DepartmentProgram from "@/views/Department/ViewProgram.vue";
import programDegree from "@/views/programDegree.vue";
import courseSections from "@/views/Course/courseSections.vue";
import CourseUnits from "@/views/Course/courseUnits.vue";
import CourseVideos from "@/views/Course/courseVideos.vue";
import Program_scheme from "@/views/Scheme/program_scheme.vue";
import ViewProgramSchemes from "@/views/Scheme/view_program_schemes.vue";
import BatchScheme from "@/views/Scheme/batch_scheme.vue";
import StreamScheme from "@/views/Scheme/stream_scheme.vue";
import AssessmentScheme from "@/views/Scheme/assessmentScheme.vue";
import ViewPSTCourses from "@/views/Scheme/view_pst_courses.vue";
import Streams from "@/views/Streams.vue";
import StreamSchemeLists from "@/views/Scheme/stream_scheme_lists.vue";
import Dashboard from "../views/Dashboard.vue";
import DashboardView from "@/views/DashboardView.vue";
import BatchView from "@/views/Batches/BatchView.vue";
import PartnerSchedule from "@/views/Batches/partnerSchedule.vue";
import ProgramBatchTermSchedules from "@/views/Batches/programBatchTermSchedules.vue";
import MISReport from "@/views/MISReport.vue";
import MISOtherReport from "@/views/MISOtherReport.vue";
import ExcessPaymentReport from "@/views/ExcessPaymentReport.vue";
import paymentOptions from "@/views/paymentOptions.vue";
import Payment from "@/views/Payment.vue";
import CFOPayment from "@/views/CFOPayment.vue";
import ApplicationStatus from "@/views/ApplicationStatus.vue";
import PartnerPayment from "@/views/PartnerPayment.vue";
import LoanPayments from "@/views/LoanPayments.vue";
import PartnerApproval from "@/views/PartnerApproval.vue";
import TransactionHistory from "@/views/TransactionHistory.vue";
import UGCDataUpload from "@/views/UGCDataUpload.vue";
import FeeTypes from "@/views/FeeTypes.vue";
import TermFeeRequest from "@/views/FeeRequest/TermFeeRequest.vue";
import TermFeeRequestYearBatch from "@/views/FeeRequest/TermFeeRequestYearBatch.vue";
import TermFeeRequestStudent from "@/views/FeeRequest/TermFeeRequestStudent.vue";
import ExamFeeRequest from "@/views/FeeRequest/ExamFeeRequest.vue";
import ExamFeeRequestYearBatch from "@/views/FeeRequest/ExamFeeRequestYearBatch.vue";
import ExamFeeRequestStudent from "@/views/FeeRequest/ExamFeeRequestStudent.vue";
import RevenueSplit from "@/views/RevenueSplitView.vue";
import ReferralsView from "@/views/ReferralsView.vue";
import ReferralVisibilityView from "@/views/ReferralVisibilityView.vue";
import AdmissionsView from "@/views/AdmissionsView.vue";
import SettlementsView from "@/views/SettlementsView.vue";
import SettlementTransactionView from "@/views/SettlementTransactionView.vue";
import VerifySettledTransactionsView from "@/views/verifySettledTransactionsView.vue";
import InternalMarkView from "@/views/Mark/InternalMark.vue";
import ExternalMarkView from "@/views/Mark/ExternalMark.vue";
import RevenueSplitSummary from "@/views/RevenueSplitSummary.vue";
import RevenueSplitFinalize from "@/views/RevenueSplitFinalize.vue";
import RevenueSplitFinalizedList from "@/views/RevenueSplitFinalizedList.vue";
import RevenueSplitPartnerView from "@/views/RevenueSplitPartnerView.vue";
import RevenueRateSetup from "@/views/revenue/RevenueRateSetup.vue";
import RevenueSummary from "@/views/revenue/RevenueSummary.vue";
import RevenueInvoices from "@/views/revenue/RevenueInvoices.vue";
import RevenueApportionment from "@/views/revenue/RevenueApportionment.vue";
import RevenueApportionmentSetup from "@/views/revenue/RevenueApportionmentSetup.vue";
import RevenueWorkingsView from "@/views/RevenueWorkingsView.vue";
import RevenueRecognitionView from "@/views/RevenueRecognitionView.vue";
import RevenueServiceInvoiceList from "@/views/RevenueServiceInvoiceList.vue";
import StudentElective from "@/views/Elective/StudentElective.vue";
import StudentElectiveCourse from "@/views/Elective/StudentElectiveCourse.vue";
import StudentElectiveCourseProgram from "@/views/Elective/StudentElectiveCourseProgram.vue";
import AcademicPayments from "@/views/AcademicPayments.vue";
import BulkPaymentSet from "@/views/BulkPayment/Set.vue";
import BulkPaymentReport from "@/views/BulkPayment/Report.vue";
import BulkPaymentReportStudentView from "@/views/BulkPayment/StudentView.vue";
import ApplicantUpdates from "@/views/ApplicantUpdates.vue";
import PhotoVerification from "@/views/PhotoVerification.vue";
import Helpdesk from "@/views/Helpdesk.vue";
import MiscellaneousFee from "@/views/MiscellaneousFee.vue";
import DocumentRequests from "@/views/DocumentRequests.vue";
import StudentDetails from "@/views/StudentDetails.vue";
import AnnouncementManagement from "@/views/AnnouncementManagement.vue";
import StudentLifecycle from "@/views/StudentLifecycle/index.vue";
import StudentExitApprovals from "@/views/StudentLifecycle/ExitRequest.vue";
import StudentDocumentViewer from "@/views/studentDocumentView.vue";
import bulkReceiptDownload from "@/views/bulkReceiptDownload.vue";
import examResult from "@/views/Mark/examResult.vue";
import StudentViewCFOVerification from "@/views/BulkPayment/StudentViewCFOVerification.vue";
import RequestPayments from "@/views/RequestPayments.vue";
import UnsettledTransactions from "@/views/UnsettledTransactions.vue";
import MISPostalFeeReport from "@/views/MISPostalFeeReport.vue";
import ReportViewNew from "@/views/Report/index.vue";
import ReportListView from "@/views/Report/list.vue";
import ReportEditView from "@/views/Report/edit.vue";
import TermSession from "@/views/TermSession/index.vue";
import StudentPaymentSession from "@/views/StudentPaymentSession.vue";
import AuditReport from "@/views/AuditReport.vue";
import StudentProgression from "@/views/StudentProgression.vue";
import Discounts from "@/views/Discounts.vue";
import StudentTransfer from "@/views/StudentTransfer.vue";
import StudentExamResult from "@/views/Mark/studentExamResult.vue";
import AnnualExamResult from "@/views/Mark/annualExamResult.vue";
import ConsolidatedFeeReport from "@/views/ConsolidatedFeeReport.vue";
import ProgramAddons from "@/views/ProgramAddons/Addons.vue";
import ProgramAddonsFeeSchedule from "@/views/ProgramAddons/AddonFeeSchedule.vue";
import StudentAddonProgrammePartner from "@/views/ProgramAddons/StudentAddonProgrammePartner.vue";
import AddonProgrammeFeeReport from "@/views/AddonProgrammeFeeReport.vue";
import AddonProgrammeMISFeeReport from "@/views/AddonProgrammeMISFeeReport.vue";
import ExcessPaymentsView from "@/views/ExcessPayments/index.vue";
import RefundsView from "@/views/Refunds/index.vue";
import RefundedView from "@/views/Refunds/Refunded.vue";
import WebinarSchedulerView from "@/views/WebinarScheduler/index.vue";
import WebinarSchedulerEntries from "@/views/WebinarScheduler/Entries.vue";
import GSTConfigurationView from "@/views/GSTConfigurationView.vue";
import BilldeskPaymentsView from "@/views/BilldeskPaymentsView.vue";
import AttendanceReport from "@/views/WebinarScheduler/AttendanceReport.vue";
import AggregateAttendanceReport from "@/views/WebinarScheduler/AggregateAttendanceReport.vue";
import StudentElectiveConfigOld from "@/views/Elective/StudentElectiveConfigOld.vue";
import StudentElectiveEnrollment from "@/views/Elective/StudentElectiveEnrollment.vue";
import StudentElectives from "@/views/Elective/StudentElectives.vue";
import StudentElectivesNew from "@/views/Elective/StudentElectivesNew.vue";
import ExamPaperView from "@/views/Elective/ExamPaperView.vue";
import RolesView from "@/views/Roles.vue";
import MenuBuilderView from "@/views/MenuBuilder.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: "/login",
    meta: {
      auth: true,
    },
    children: [
      {
        path: "operational_dashboard",
        name: "Operational Dashboard",
        component: ReportViewNew,
        meta: {
          auth: true,
        },
      },
      {
        path: "operational_dashboard/list",
        name: "Operational Dashboard List",
        component: ReportListView,
        meta: {
          auth: true,
        },
      },
      {
        path: "operational_dashboard/edit",
        name: "Operational Dashboard Edit",
        component: ReportEditView,
        meta: {
          auth: true,
        },
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          auth: true,
        },
      },
      {
        path: "dashboard_view",
        name: "Dashboard View",
        component: DashboardView,
        meta: {
          auth: true,
        },
      },
      {
        path: "admission_report",
        name: "Admission Report",
        component: MISReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "fee_report",
        name: "Fee Report",
        component: MISOtherReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "excess_payment_report",
        name: "Excess Report",
        component: ExcessPaymentReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "payment",
        name: "Payment",
        component: Payment,
        meta: {
          auth: true,
        },
      },
      {
        path: "collection-report",
        name: "Collections Report",
        component: Payment,
        meta: {
          auth: true,
        },
      },
      {
        path: "admission-payment",
        name: "Admission",
        component: Payment,
        meta: {
          auth: true,
        },
      },
      {
        path: "other-payment",
        name: "Fee",
        component: AcademicPayments,
        meta: {
          auth: true,
        },
      },
      {
        path: "cfo_payment",
        name: "Transaction Verification",
        component: CFOPayment,
        meta: {
          auth: true,
        },
      },
      {
        path: "set_payment_options",
        name: "Set Payment Options",
        component: PartnerPayment,
        meta: {
          auth: true,
        },
      },
      {
        path: "loan_payments",
        name: "Loan Payments",
        component: LoanPayments,
        meta: {
          auth: true,
        },
      },
      {
        path: "approvals",
        name: "Approvals",
        component: PartnerApproval,
        meta: {
          auth: true,
        },
      },
      {
        path: "admissions",
        name: "Admissions",
        component: AdmissionsView,
        meta: {
          auth: true,
        },
      },
      {
        path: "application_status",
        name: "Application Status",
        component: ApplicationStatus,
        meta: {
          auth: true,
        },
      },
      {
        path: "degree",
        name: "Degree",
        component: DegreeView,
        meta: {
          auth: true,
        },
      },
      {
        path: "users",
        name: "Users",
        component: UserView,
        meta: {
          auth: true,
        },
      },
      {
        path: "roles",
        name: "Roles",
        component: RolesView,
        meta: {
          auth: true,
        },
      },
      {
        path: "menu_builder",
        name: "Menu Builder",
        component: MenuBuilderView,
        meta: {
          auth: true,
        },
      },
      {
        path: "departments",
        name: "Departments",
        component: DepartmentView,
        meta: {
          auth: true,
        },
      },
      {
        path: "programmes",
        name: "Programmes",
        component: ProgramView,

        meta: {
          auth: true,
        },
      },
      {
        path: "courses",
        name: "Courses",
        component: CoursesView,
        meta: {
          auth: true,
        },
      },
      {
        path: "partners",
        name: "Partners",
        component: PartnerView,
        meta: {
          auth: true,
        },
      },
      {
        path: "partner/:id",
        name: "View Partner",
        component: viewPartnerLink,
        meta: {
          auth: true,
        },
      },
      {
        path: "partner/:id/:code",
        name: "View Partner Code",
        component: viewPartnerLink,
        meta: {
          auth: true,
        },
      },
      {
        path: "program_application",
        name: "Programme",
        component: ProgramApplicationSchedule,
        meta: {
          auth: true,
        },
      },
      {
        path: "program_partner",
        name: "Partner Admission Schedule",
        component: ProgramPartnerSchedule,
        meta: {
          auth: true,
        },
      },
      {
        path: "/program_partner/partner/:id",
        name: "View Partner Add-on Programme",
        component: viewPartnerScheduleLink,
        meta: {
          auth: true,
        },
      },
      {
        path: "/program_partner/partner/:id/:code",
        name: "View Partner Add-on Programme Code",
        component: viewPartnerScheduleLink,
        meta: {
          auth: true,
        },
      },
      {
        path: "sub_partner",
        name: "Sub Partners",
        component: SubPartner,
        meta: {
          auth: true,
        },
      },
      {
        path: "sub_partner/branches/:id",
        name: "View Sub Partner",
        component: viewSubPartnerLink,
        meta: {
          auth: true,
        },
      },
      {
        path: "sub_partner/branches/:id/:code",
        name: "View Sub Partner Code",
        component: viewSubPartnerLink,
        meta: {
          auth: true,
        },
      },
      {
        path: "partner_branches",
        name: "Partner Branches",
        component: PartnerBranches,
        meta: {
          auth: true,
        },
      },
      {
        path: "code_generation",
        name: "Partner URL",
        component: GenerateCodeView,
        meta: {
          auth: true,
        },
      },
      {
        path: "departments/:id",
        name: "View",
        component: OverallDepartmentsView,
        meta: {
          auth: true,
        },
      },
      {
        path: "departments/:id/courses",
        name: "departments/:id/courses",
        component: DepartmentCourse,
        meta: {
          auth: true,
        },
      },
      {
        path: "departments/:id/programs",
        name: "departments/:id/programs",
        component: DepartmentProgram,
        meta: {
          auth: true,
        },
      },
      {
        path: "programs/:id/:name",
        name: "programs/:id/:name",
        component: programDegree,
        meta: {
          auth: true,
        },
      },
      {
        path: "course_sections",
        name: "Course Sections",
        component: courseSections,
        meta: {
          auth: true,
        },
      },
      {
        path: "course_units",
        name: "Course Units",
        component: CourseUnits,
        meta: {
          auth: true,
        },
      },
      {
        path: "video_courses",
        name: "Video Courses",
        component: CourseVideos,
        meta: {
          auth: true,
        },
      },
      {
        path: "batch_scheme",
        name: "Batch Schemes",
        component: BatchScheme,
        meta: {
          auth: true,
        },
      },
      {
        path: "program_scheme",
        name: "Programme Schemes",
        component: Program_scheme,
        meta: {
          auth: true,
        },
      },
      {
        path: "stream_scheme",
        name: "Stream Schemes",
        component: StreamScheme,
        meta: {
          auth: true,
        },
      },
      {
        path: "assessment_scheme",
        name: "Assessment Schemes",
        component: AssessmentScheme,
        meta: {
          auth: true,
        },
      },
      {
        path: "view_program_schemes",
        name: "View Programme Schemes",
        component: ViewProgramSchemes,
        meta: {
          auth: true,
        },
      },
      {
        path: "view_pst_courses",
        name: "View Term Courses",
        component: ViewPSTCourses,
        meta: {
          auth: true,
        },
      },
      {
        path: "streams",
        name: "Streams",
        component: Streams,
        meta: {
          auth: true,
        },
      },
      {
        path: "stream_scheme_lists",
        name: "Stream Scheme Lists",
        component: StreamSchemeLists,
        meta: {
          auth: true,
        },
      },
      {
        path: "batches",
        name: "Batches",
        component: BatchView,
        meta: {
          auth: true,
        },
      },
      {
        path: "partner_schedule",
        name: "Schedule Batches",
        component: PartnerSchedule,
        meta: {
          auth: true,
        },
      },
      {
        path: "program_batch_term_schedule",
        name: "Program Batch Term Schedules",
        component: ProgramBatchTermSchedules,
        meta: {
          auth: true,
        },
      },
      {
        path: "payment-options",
        name: "Payment Options",
        component: paymentOptions,
        meta: {
          auth: true,
        },
      },
      {
        path: "transaction-history",
        name: "Transaction History",
        component: TransactionHistory,
        meta: {
          auth: true,
        },
      },
      {
        path: "student-info-updates",
        name: "Info Updates",
        component: ApplicantUpdates,
        meta: {
          auth: true,
        },
      },
      {
        path: "student-details",
        name: "Student Details",
        component: StudentDetails,
        meta: {
          auth: true,
        },
      },
      {
        path: "announcements",
        name: "Announcements",
        component: AnnouncementManagement,
        meta: {
          auth: true,
        },
      },
      {
        path: "photo-verification",
        name: "Image Verification",
        component: PhotoVerification,
        meta: {
          auth: true,
        },
      },
      {
        path: "helpdesk",
        name: "Helpdesk",
        component: Helpdesk,
        meta: {
          auth: true,
        },
      },
      {
        path: "miscellaneous_fee",
        name: "Miscellaneous Fee",
        component: MiscellaneousFee,
        meta: {
          auth: true,
        },
      },
      {
        path: "document_requests",
        name: "Requests",
        component: DocumentRequests,
        meta: {
          auth: true,
        },
      },
      {
        path: "ugc-data-upload",
        name: "UGC Data Upload",
        component: UGCDataUpload,
        meta: {
          auth: true,
        },
      },
      {
        path: "fee-types",
        name: "Fee Types",
        component: FeeTypes,
        meta: {
          auth: true,
        },
      },
      {
        path: "gst-configuration",
        name: "GST Configuration",
        component: GSTConfigurationView,
        meta: {
          auth: true,
        },
      },
      {
        path: "billdesk-payments",
        name: "BillDesk Payments",
        component: BilldeskPaymentsView,
        meta: {
          auth: true,
        },
      },
      {
        path: "term-fee-request",
        name: "Term Invoice",
        component: TermFeeRequest,
        meta: {
          auth: true,
        },
      },
      {
        path: "term-fee-request-year-batch",
        name: "Term Invoice Year Batch",
        component: TermFeeRequestYearBatch,
        meta: {
          auth: true,
        },
      },
      {
        path: "term_fee_student",
        name: "Term Invoice Student",
        component: TermFeeRequestStudent,
        meta: {
          auth: true,
        },
      },
      {
        path: "exam-fee-request",
        name: "Exam Invoice",
        component: ExamFeeRequest,
        meta: {
          auth: true,
        },
      },
      {
        path: "exam-fee-request-year-batch",
        name: "Exam Invoice Year Batch",
        component: ExamFeeRequestYearBatch,
        meta: {
          auth: true,
        },
      },
      {
        path: "exam_fee_student",
        name: "Exam Invoice Student",
        component: ExamFeeRequestStudent,
        meta: {
          auth: true,
        },
      },
      {
        path: "revenue-split",
        name: "Partner Revenue Split",
        component: RevenueSplit,
        meta: {
          auth: true,
        },
      },
      {
        path: "referrals",
        name: "Referrals",
        component: ReferralsView,
        meta: {
          auth: true,
        },
      },
      {
        path: "referral_visibility",
        name: "Referral Visibility",
        component: ReferralVisibilityView,
        meta: {
          auth: true,
        },
      },
      {
        path: "settlements",
        name: "Settlements",
        component: SettlementsView,
        meta: {
          auth: true,
        },
      },
      {
        path: "settlements/:id/transactions",
        name: "settlements/:id/transactions",
        component: SettlementTransactionView,
        meta: {
          auth: true,
        },
      },

      {
        path: "revenue-split-summary/:id",
        name: "RevenueSplitSummary",
        component: RevenueSplitSummary,
        meta: {
          auth: true,
        },
      },
      {
        path: "settlements/:id/verify-transactions",
        name: "settlements/:id/verify-transactions",
        component: VerifySettledTransactionsView,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_elective",
        name: "Elective",
        component: StudentElective,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_elective_course",
        name: "Student Elective Course",
        component: StudentElectiveCourse,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_elective_course_program",
        name: "Student Elective Course Program",
        component: StudentElectiveCourseProgram,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_elective_configs_old",
        name: "Elective Configuration Old",
        component: StudentElectiveConfigOld,
        meta: {
          auth: true,
        },
      },
      {
        path: "elective_enrollment",
        name: "Elective Enrollment",
        component: StudentElectiveEnrollment,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_electives",
        name: "Student Electives",
        component: StudentElectives,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_electives_new",
        name: "Student Electives New",
        component: StudentElectivesNew,
        meta: {
          auth: true,
        },
      },
      {
        path: "exam_papers",
        name: "Exam Paper",
        component: ExamPaperView,
        meta: {
          auth: true,
        },
      },
      {
        path: "bulk_payments",
        name: "Set Bulk Payments",
        component: BulkPaymentSet,
        meta: {
          auth: true,
        },
      },
      {
        path: "bulk_payment_report",
        name: "Bulk Payments",
        component: BulkPaymentReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "bulk_payment_students",
        name: "Bulk Student Payments",
        component: BulkPaymentReportStudentView,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_lifecycle",
        name: "Lifecycle",
        component: StudentLifecycle,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_exit_approvals",
        name: "Exit Approvals",
        component: StudentExitApprovals,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_document_viewer",
        name: "Document Viewer",
        component: StudentDocumentViewer,
        meta: {
          auth: true,
        },
      },
      {
        path: "bulk_receipt_download",
        name: "Bulk Receipt Download",
        component: bulkReceiptDownload,
        meta: {
          auth: true,
        },
      },
      {
        path: "internal-marks",
        name: "Internal",
        component: InternalMarkView,
        meta: {
          auth: true,
        },
      },
      {
        path: "external-marks",
        name: "External",
        component: ExternalMarkView,
        meta: {
          auth: true,
        },
      },
      {
        path: "exam_results",
        name: "Exam Result",
        component: examResult,
        meta: {
          auth: true,
        },
      },
      {
        path: "cfo_bulk_payment_students",
        name: "Bulk Payments Verification",
        component: StudentViewCFOVerification,
        meta: {
          auth: true,
        },
      },
      {
        path: "request-payment",
        name: "Request Fee",
        component: RequestPayments,
        meta: {
          auth: true,
        },
      },
      {
        path: "add-on_programme_fee",
        name: "Add-on Programme Fee",
        component: AddonProgrammeFeeReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "unsettled-transactions",
        name: "Unsettled Transactions",
        component: UnsettledTransactions,
        meta: {
          auth: true,
        },
      },
      {
        path: "postal_fee_report",
        name: "Requests Fee report",
        component: MISPostalFeeReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "addon_programme_report",
        name: "Add-on Programme Report",
        component: AddonProgrammeMISFeeReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "term_sessions",
        name: "Term Session",
        component: TermSession,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_payment_sessions",
        name: "Student Payment Session",
        component: StudentPaymentSession,
        meta: {
          auth: true,
        },
      },
      {
        path: "audit-report",
        name: "Audit Report",
        component: AuditReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_progressions",
        name: "Student Progression",
        component: StudentProgression,
        meta: {
          auth: true,
        },
      },
      {
        path: "discounts",
        name: "Discounts",
        component: Discounts,
        meta: {
          auth: true,
        },
      },
      {
        path: "batch_transfer",
        name: "Batch Transfer",
        component: StudentTransfer,
        meta: {
          auth: true,
        },
      },
      {
        path: "student_exam_result",
        name: "Student Exam Result",
        component: StudentExamResult,
        meta: {
          auth: true,
        },
      },
      {
        path: "annual_exam_result",
        name: "Annual Exam Result",
        component: AnnualExamResult,
        meta: {
          auth: true,
        },
      },
      {
        path: "consolidated_fee_report",
        name: "Consolidated Fee",
        component: ConsolidatedFeeReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "program_addons",
        name: "Add-on Programmes",
        component: ProgramAddons,
        meta: {
          auth: true,
        },
      },
      {
        path: "program_addons_fee_schedule",
        name: "Addons Fee Schedule",
        component: ProgramAddonsFeeSchedule,
        meta: {
          auth: true,
        },
      },
      {
        path: "programme_addon_referral",
        name: "Add-on Programme Referral",
        component: StudentAddonProgrammePartner,
        meta: {
          auth: true,
        },
      },
      {
        path: "excess-payments",
        name: "Excess Payments",
        component: ExcessPaymentsView,
        meta: {
          auth: true,
        },
      },
      {
        path: "refunds",
        name: "Refunds",
        component: RefundsView,
        meta: {
          auth: true,
          viewer: ["Admin", "CFO", "Management", "Reviewer"],
        },
      },
      {
        path: "refunded",
        name: "Refunded",
        component: RefundedView,
        meta: {
          auth: true,
          viewer: ["Admin", "CFO", "Management", "Reviewer"],
        },
      },
      {
        path: "webinar-scheduler",
        name: "Webinar Scheduler",
        component: WebinarSchedulerView,
        meta: {
          auth: true,
        },
      },
      {
        path: "attendance_report/:entryId",
        name: "Attendance Report",
        component: AttendanceReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "webinar-attendance-report",
        name: "Webinar Attendance Report",
        component: AggregateAttendanceReport,
        meta: {
          auth: true,
        },
      },
      {
        path: "webinar-scheduler/:runId/entries",
        name: "Webinar Scheduler Entries",
        component: WebinarSchedulerEntries,
        meta: {
          auth: true,
        },
      },
      {
        path: "revenue-split-finalize",
        name: "RevenueSplitFinalize",
        component: RevenueSplitFinalize,
        meta: {
          auth: true,
        },
      },
      {
        path: "revenue-split-finalized",
        name: "RevenueSplitFinalizedList",
        component: RevenueSplitFinalizedList,
        meta: {
          auth: true,
        },
      },
      {
        path: "revenue-split-view",
        name: "Revenue Split",
        component: RevenueSplitPartnerView,
        meta: {
          auth: true,
        },
      },
      {
        path: "revenue-setup",
        name: "Revenue Setup",
        component: RevenueRateSetup,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },
      {
        path: "revenue-summary",
        name: "Revenue Summary",
        component: RevenueSummary,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },
      {
        path: "revenue-invoices",
        name: "Revenue Invoices",
        component: RevenueInvoices,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },
      {
        path: "revenue-apportionment-setup",
        name: "Revenue Apportionment Setup",
        component: RevenueApportionmentSetup,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },
      {
        path: "revenue-apportionment",
        name: "Revenue Apportionment",
        component: RevenueApportionment,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },
      {
        path: "revenue-workings",
        name: "RevenueWorkings",
        component: RevenueWorkingsView,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },
      {
        path: "revenue-recognition",
        name: "RevenueRecognition",
        component: RevenueRecognitionView,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },
      {
        path: "revenue-service-invoices",
        name: "RevenueServiceInvoices",
        component: RevenueServiceInvoiceList,
        meta: {
          auth: true,
          viewer: ["Admin", "Management"],
        },
      },

    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/* to resolve error: Avoided redundant navigation to current location */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// Access is decided entirely by currentUser.modules, the flat list of module
// (= route name) keys the backend resolves for the user at login/find_me time
// (role-granted modules, plus any flag-based bonus modules — e.g. a partner
// flag unlocking "Partner"/"Business" role pages — already folded in server
// side; see ChalknBoard.Roles.effective_module_names/1). The frontend does not
// keep its own copy of who-can-see-what: it just checks membership.
function hasRouteAccess(to, currentUser) {
  return (
    Array.isArray(currentUser?.modules) && currentUser.modules.includes(to.name)
  );
}

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("token");

  if (token && !store.state.currentUser) {
    try {
      // Wait for the store to initialize the currentUser if not already
      await store.dispatch("initializeUser");
    } catch (err) {
      localStorage.removeItem("token");
      return next("/login");
    }
  }

  const currentUser = store.state.currentUser;
  if (
    to.meta?.auth &&
    (!token || !hasRouteAccess(to, currentUser))
  ) {
    return next("/login");
  }
  next();
});
export default router;
